import { toast } from '@/lib/toast';
import type { ApiErrorType } from '@/types/global.types';
import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * Display a toast message for an API error
 * @param error - The error object from a query/mutation
 * @param message - Fallback message if no error message is found in the error object
 */
export const errorToast = (
  error: FetchBaseQueryError | SerializedError | unknown | undefined,
  message: string,
) => {
  if (error) {
    const err = error as ApiErrorType;
    const msg = err.data?.message?.message || err.data?.message;
    toast('error', msg && typeof msg === 'string' ? msg : message);
  }
};
